// extracted by mini-css-extract-plugin
export var container = "_ft-0";
export var dotAnimation = "_ft-2";
export var dotsLoading = "_ft-1";